var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { forwardRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { QueryList } from '@angular/core';
import { UIRadioComponent } from './radio.component';
import { noop, merge } from 'rxjs';
var RADIO_CONTROL_VALUE_ACCESSOR = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(function () { return UIRadioGroupComponent; }),
    multi: true
};
var UIRadioGroupComponent = /** @class */ (function () {
    function UIRadioGroupComponent() {
        this._onChange = noop;
        this._onTouched = noop;
    }
    UIRadioGroupComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        var emitters = merge.apply(void 0, __spread(this.radios.map(function (option) { return option.onCheckRadio; })));
        this._radioSubscription = emitters.subscribe(function (radio) {
            _this._onCheck(radio);
        });
    };
    UIRadioGroupComponent.prototype.ngOnDestroy = function () {
        this._destroyRadios();
    };
    UIRadioGroupComponent.prototype._onCheck = function (selectedRadio) {
        this.radios.forEach(function (radio) {
            radio.checked = (radio === selectedRadio);
        });
        this._onChange(selectedRadio.value);
        this._onTouched();
    };
    UIRadioGroupComponent.prototype._setOptionByValue = function (value) {
        var _this = this;
        this.radios.forEach(function (radio) {
            if (radio.value === value) {
                _this._onCheck(radio);
            }
        });
    };
    UIRadioGroupComponent.prototype._destroyRadios = function () {
        if (this._radioSubscription) {
            this._radioSubscription.unsubscribe();
            this._radioSubscription = null;
        }
    };
    UIRadioGroupComponent.prototype.writeValue = function (value) {
        if (this.radios) {
            this._setOptionByValue(value);
        }
    };
    UIRadioGroupComponent.prototype.registerOnChange = function (fn) {
        this._onChange = fn;
    };
    UIRadioGroupComponent.prototype.registerOnTouched = function (fn) {
        this._onTouched = fn;
    };
    UIRadioGroupComponent.prototype.setDisabledState = function (disabled) {
        this.disabled = disabled;
        if (this.radios) {
            this.radios.forEach(function (radio) {
                radio.disabled = disabled;
            });
        }
    };
    return UIRadioGroupComponent;
}());
export { UIRadioGroupComponent };
